import { Card, Center, Group, ScrollArea, Stack, Table, Tabs, TabsList, TabsPanel, Text } from "@mantine/core";
import { useEffect, useState } from "react";

function FlightTable(props: { tournament: any, flight: any, scores: any[] }) {
    const [rows, setRows] = useState<any[]>([])

    const getFinish = (score: any) => {
        return score.finish
            ? score.finish.length === 1
                ? score.finish[0]
                : 'T' + score.finish[0]
            : ''
    }

    const getFlightSize = () => {
        return props.tournament.flights.find(f => f.name === props.flight).size
    }

    useEffect(() => {
        if (props.scores) {
            setRows(props.scores.map((s: any, idx) =>
                <Table.Tr key={idx}>
                    {props.tournament.flights && <Table.Td> <Text>{getFinish(s)}</Text></Table.Td>}
                    <Table.Td> <Text fw={600} >{s.playerName}</Text></Table.Td>
                    <Table.Td>{s.handicap}</Table.Td>
                    <Table.Td>{s.total}</Table.Td>
                    <Table.Td bg={'var(--mantine-color-blue-light)'}>{s.totalNet}</Table.Td>
                    <Table.Td>{s.handicap1}</Table.Td>
                    <Table.Td>{s.total1}</Table.Td>
                    <Table.Td>{s.totalNet1}</Table.Td>
                    <Table.Td>{s.handicap2}</Table.Td>
                    <Table.Td>{s.total2}</Table.Td>
                    <Table.Td>{s.totalNet2}</Table.Td>
                </Table.Tr>
            ))
        }
    }, [props])

    return <ScrollArea style={{ overflowY: "auto" }}>
        <Table>
            <Table.Thead>
                <Table.Tr>
                    {props.tournament.flights && <Table.Th w={150}>Finish</Table.Th>}
                    <Table.Th w={200}>Player</Table.Th>
                    <Table.Th w={150}>HDCP</Table.Th>
                    <Table.Th w={150}>Total</Table.Th>
                    <Table.Th w={150} bg={'var(--mantine-color-blue-light)'}>Total Net</Table.Th>
                    <Table.Th w={150}>HDCP 1</Table.Th>
                    <Table.Th w={150}>Total 1</Table.Th>
                    <Table.Th w={150}>Total Net 1</Table.Th>
                    <Table.Th w={150}>HDCP 2</Table.Th>
                    <Table.Th w={150}>Total 2</Table.Th>
                    <Table.Th w={150}>Total Net 2</Table.Th>
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
            {props.tournament.flights &&
                <Table.Tfoot>
                    <Table.Tr>
                        <Table.Th colSpan={11}>Flight Size: {getFlightSize()}</Table.Th>
                    </Table.Tr>
                </Table.Tfoot>
            }
        </Table>
    </ScrollArea>
}

function TwoDayCard(props: { tournament: any, title?: string }) {
    const [flights, setFlights] = useState<string[]>()
    const [allRounds, setAllRounds] = useState<any[]>([])
    const [rounds, setRounds] = useState({})

    useEffect(() => {
        if (props.tournament) {
            setAllRounds(props.tournament.rounds)
            setFlights(Array.from(new Set(props.tournament.rounds.map(r => r.flight)))
                .sort((f1: string, f2: string) => f1.localeCompare(f2)) as string[])
        }
    }, [props])

    useEffect(() => {
        if (flights && allRounds) {
            console.log('flights', flights)
            console.log('allRounds', allRounds)
            const map = {}
            flights.forEach(f =>
                map[f] = allRounds
                    .filter(r => r.flight === f)
                    .sort((r1, r2) => {
                        if (!r1.totalNet) {
                            return 1
                        }
                        if (!r2.totalNet) {
                            return -1
                        }
                        return r1.totalNet - r2.totalNet
                    }))
            setRounds(map)
        }
    }, [flights, allRounds])

    if (!props.tournament) {
        return <Card>
            No tournament listed.
        </Card>
    }

    return <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Card.Section>
            <Center h={80} bg="var(--mantine-color-gray-light)">
                <Text fw={800} >{props.title}</Text>
            </Center>
        </Card.Section>
        <Stack>
            <Group>
                <Text fw={800}>Day One: </Text><Text>{props.tournament.course1}</Text>
                <Text fw={800}>Day Two: </Text><Text>{props.tournament.course2}</Text>
            </Group>
            {flights && <Tabs defaultValue={flights[0]} >
                <TabsList>
                    {flights.map((f, idx) =>
                        <Tabs.Tab key={idx} value={f}>
                            <Text fw={800} >{f}</Text>
                        </Tabs.Tab>)}
                </TabsList>
                {flights.map((f, idx) => <TabsPanel key={idx} value={f}>
                    <FlightTable
                        tournament={props.tournament}
                        flight={f}
                        scores={rounds[f]} />
                </TabsPanel>)}
            </Tabs>}
        </Stack>
    </Card>
}

export default TwoDayCard;